import React, { memo, useState } from 'react';

import { CheckInIcon, CheckOutIcon } from '@assets/icons';
import CustomIcon from '@components/utils/CustomIcon';
import Markdown from '@components/utils/Markdown';
import { ReadMoreSection } from '@components/cards/summaries/hotel/SummaryCard';
import Typography from '@components/Typography';

import {
  StyledBoxItemContent,
  StyledBoxItemLabel,
  StyledBoxItemDesktop,
  StyledBodyDesktop,
  StyledBoxFooter,
  StyledBoxFooterContent,
  StyledBoxFooterItem,
  StyledBoxFooterTitle,
  Section,
  StyledFooterTitle,
  StyledItemContent,
  StyledFooterDescription,
} from './RulesStyle';

export interface RulesProps {
  checkinBeginTime?: string;
  checkinEndTime?: string;
  optionalFee?: string;
  checkoutTime?: string;
  mandatoryFee?: string;
  checkinInstruction?: string;
  checkinSpecialInstruction?: string;
}

const LIMIT = 200;

const RulesBodyDesktop = ({
  mandatoryFee = '',
  optionalFee = '',
  checkinEndTime = '',
  checkinBeginTime = '',
  checkoutTime = '',
  checkinInstruction = '',
  checkinSpecialInstruction = '',
}: RulesProps) => {
  const [isReadMore, setIsReadMore] = useState<boolean>();
  const onReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <div>
      <StyledBodyDesktop>
        <StyledBoxItemDesktop>
          <CustomIcon icon={CheckInIcon} width={56} height={64} />
          <StyledBoxItemContent>
            <StyledBoxItemLabel>Giriş (Check-in)</StyledBoxItemLabel>
            <Typography variant='caption' weight='Bold'>
              {checkinBeginTime}-{checkinEndTime}
            </Typography>
          </StyledBoxItemContent>
        </StyledBoxItemDesktop>

        <StyledBoxItemDesktop>
          <CustomIcon icon={CheckOutIcon} width={56} height={64} />
          <StyledBoxItemContent>
            <StyledBoxItemLabel>Çıkış (Check-out)</StyledBoxItemLabel>
            <Typography variant='caption' weight='Bold'>
              {checkoutTime}
            </Typography>
          </StyledBoxItemContent>
        </StyledBoxItemDesktop>
      </StyledBodyDesktop>

      <StyledBoxFooter>
        <StyledBoxFooterContent>
          <StyledBoxFooterItem>
            <StyledBoxFooterTitle>Zorunlu Ücretler</StyledBoxFooterTitle>
            <Typography variant='caption1' color='darkGrey'>
              <Markdown text={mandatoryFee} />
            </Typography>
          </StyledBoxFooterItem>

          <StyledBoxFooterItem>
            <StyledBoxFooterTitle>Opsiyonel Ücretler</StyledBoxFooterTitle>
            <Typography variant='caption1' color='darkGrey'>
              <Markdown
                text={
                  isReadMore ? optionalFee : optionalFee.substring(0, LIMIT)
                }
              />
              {optionalFee.length > LIMIT ? (
                <Section>
                  <ReadMoreSection
                    text={!isReadMore ? 'Devamını Oku' : 'Daha az göster'}
                    onClick={onReadMore}
                  />
                </Section>
              ) : null}
            </Typography>
            <StyledItemContent>
              <StyledFooterTitle>Check-in Açıklamaları</StyledFooterTitle>
              <StyledFooterDescription>
                <Markdown text={checkinInstruction} />
              </StyledFooterDescription>
              <StyledFooterDescription>
                {checkinSpecialInstruction}
              </StyledFooterDescription>
            </StyledItemContent>
          </StyledBoxFooterItem>
        </StyledBoxFooterContent>
      </StyledBoxFooter>
    </div>
  );
};

export default memo(RulesBodyDesktop);
